<template>
  <div class="chart">
    <apexchart ref="chart" type="pie" height="380" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
  import VueApexCharts from 'vue-apexcharts'
  export default {
    name: 'DsbPuJenisSektorIndustriDanJumlahPU',
    components: {
      apexchart: VueApexCharts,
    },
    props: {
      models: {
          type: Object,
          required: true,
      },
    },
    mounted(){
        this.getData();
    },
    methods: {
      getData(){
          const _ = this;
          _.$axios.get('PelakuUsahaDashboard/JenisSektorIndustriDanJumlahPU')
          .then(res => {
              let data = res.data.data;
              _.series = [];
              _.chartOptions.labels = [];
              data.map((item, index) => {
                  _.series.push(item.persentase);
                  _.chartOptions.labels.push(item.jenisKegiatanUsaha);
              });
              _.$nextTick(() => {
                _.$refs.chart.init();
              });
          })
      },
    },
    data: function () {
      return {
        series: [],
        chartOptions: {
          title: {
            text: "Jenis Sektor Industri dan Jumlah Pelaku Usaha, tahun " + this.models.year,
          },
          chart: {
            width: 380,
            type: 'pie',
            events: {
              mounted: (chart) => {
                chart.windowResizeHandler();
              }
            }
          },
          labels: [],
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }]
        }
      }
    },
    watch: {
      models: {
          handler(newVal, oldVal) {
              this.chartOptions.title.text = "Jenis Sektor Industri dan Jumlah Pelaku Usaha, tahun " + this.models.year;
          },
          deep: true,
      },
    },
  }
</script>